import { spawn } from 'node:child_process'

export function spawnAsync(cmd: string, args: string[], cwd: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const child = spawn(cmd, args, { cwd, stdio: 'pipe' })
    let stdout = ''
    let stderr = ''
    child.stdout?.on('data', (chunk: Buffer) => {
      stdout += chunk.toString()
    })
    child.stderr?.on('data', (chunk: Buffer) => {
      stderr += chunk.toString()
    })
    child.on('close', (code) => {
      if (code === 0) resolve()
      else {
        const output = [stdout.trim(), stderr.trim()].filter(Boolean).join('\n')
        reject(new Error(output || `${cmd} exited with code ${code}`))
      }
    })
    child.on('error', reject)
  })
}
